<!-- //
table栏的漏斗标题过滤_单选
@author xuyd
@date 2024-5-1
//-->
<template>
  <div class="funnel-title">
    <el-popover
        v-model="visible"
        trigger="click"
        popper-class="filterClass"
        placement="bottom"
        ref="refPopover">
      <svg-icon icon="funnel" className="filter-icon" slot="reference" :style="{color: active ? '#1f47ab' : ''}"></svg-icon>
      <div>
        <el-scrollbar>
          <div class="vertical" style="height: auto;max-height: 200px; overflow: auto">
            <el-radio-group
                v-model="inputData"
                class="vertical"
                :max="1">
              <el-radio
                  v-for="(item, index) in dataSource"
                  :key="index"
                  :label="item.value"
                  style="display: block; line-height: 32px">
                {{ item.label }}
              </el-radio>
            </el-radio-group>
          </div>
        </el-scrollbar>
        <div>
          <el-button size="small" type="text" @click="handleConfirm" :disabled="!active">筛选</el-button>
          <el-button size="small" type="text" style="color: #606266" @click="handleReset">重置</el-button>
        </div>
      </div>
    </el-popover>
  </div>
</template>
<script>
export default {
  name: 'FunnelSingleSelect',
  data() {
    return {
      visible: false,
      active: false,
      hasFilter: [],
      originalData: this.storeOriginal(this.value),
      inputData: this.value,
    };
  },
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    value: [String, Number],
    dataSource: {
      type: Array,
      default: function () {
        return []
      },
    },
  },
  computed: {},
  watch: {
    value: {
      handler(val) {
        this.inputData = val;
      },
      immediate: true
    },
    inputData: {
      handler(val) {
        this.active = !this.$util.isEmpty(val);
      },
      immediate: true
    },
  },
  methods: {
    storeOriginal(data) {
      if (this.$util.isEmpty(data)) {
        return null;
      }
      let type = typeof data;
      if (type === 'string' || type === 'number') {
        return data;
      }
      return JSON.parse(JSON.stringify(data));
    },

    handleConfirm() {
      this.visible = false;
      this.$emit('change', this.inputData)
    },
    handleReset() {
      this.visible = false;
      this.inputData = this.originalData;
      this.$emit('change', this.inputData)
    },

  }
}
</script>

<style lang="less" scoped>
.funnel-title {
  display: flex;
  align-items: center;
}

.filter-icon {
  width: 14px!important;;
  height: 14px!important;;
  color: #6a6a6a;
  margin-top: 5px;
  margin-left: 5px;
  cursor: pointer;
}

.filter-icon:hover {
  color: #333333;
}

.vertical {
  display: flex;
  flex-direction: column;
}
</style>
